import React, { useState } from "react"
import TextField from "@material-ui/core/TextField"
import Grid from "@material-ui/core/Grid"
import { subYears } from "date-fns"
import { useRouter } from "../../../hooks"
import { useTranslations } from "./useTranslations"

const CompletedProjectsFilter = ({ onChange }: Props) => {
  const translations = useTranslations()
  const { query: routerQuery } = useRouter()
  const [startDate, setStartDate] = useState<string>(subYears(new Date(), 1).toISOString().slice(0, 10))
  const [endDate, setEndDate] = useState<string>(new Date().toISOString().slice(0, 10))

  React.useEffect(() => {
    if (routerQuery) {
      setStartDate(subYears(new Date(), 1).toISOString().slice(0, 10))
      setEndDate(new Date().toISOString().slice(0, 10))
    }
  }, [routerQuery])

  const handleChange = (field: "startDate" | "endDate", value: string) => {
    let newStartDate = new Date(startDate).toISOString()
    let newEndDate = new Date(endDate).toISOString()

    if (field === "startDate") newStartDate = new Date(value).toISOString()
    if (field === "endDate") newEndDate = new Date(value).toISOString()

    setStartDate(newStartDate.slice(0, 10))
    setEndDate(newEndDate.slice(0, 10))

    onChange({
      startDate: newStartDate,
      endDate: newEndDate,
    })
  }

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs>
        <TextField
          fullWidth
          label={translations.fromDatedPickerLabel}
          type="date"
          value={startDate}
          onChange={(e) => handleChange("startDate", e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
        />
      </Grid>
      <Grid item xs>
        <TextField
          fullWidth
          label={translations.toDatedPickerLabel}
          type="date"
          value={endDate}
          onChange={(e) => handleChange("endDate", e.target.value)}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
        />
      </Grid>
    </Grid>
  )
}

export default CompletedProjectsFilter

type Props = {
  onChange: (values: { startDate: string; endDate: string }) => void
}
